import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { LoginAnnouncementMutationKeys } from '../../../keys'
import { deleteLoginAnnouncement } from '../../services'

interface UseMutationDeleteLoginAnnouncementProps {
	id: string
}

export default function useMutationDeleteLoginAnnouncement(
	props?: UseBaseMutationOptions<void, UseMutationDeleteLoginAnnouncementProps>,
) {
	return useMutation({
		mutationKey: [LoginAnnouncementMutationKeys.DeleteLoginAnnouncement],
		mutationFn: ({ id }) => deleteLoginAnnouncement(id),
		...props,
	})
}
